<template>
  <div style="background-color: rgba(255, 255, 255, 0.8);width: 100%;height: 100%;">
    <div v-if="reportData === ''" style="height: 100%;width: 60%;margin-left: calc(20% - 90px);background-color: #fff;overflow-y: auto;">
      <div style="width: 90%;margin-left: 5%;">
        <el-row style="height: 50px;" />
        <el-row style="height: 70px;font-size: 30px;font-weight: bold;">
          碳 盘 查
        </el-row>
        <el-row style="height: 60px;font-size: 18px;font-weight: bold;">
          遵循《中国行业温室气体排放核算方法与报告指南》
        </el-row>
        <el-row style="height: 40px;line-height: 40px;text-align: left;font-size: 14px;">
          基本信息
        </el-row>
        <el-form :model="infoForm" :rules="rules" ref="infoForm" label-width="200px" style="height: 310px;padding: 22px 20% 0 20%;background-color: rgba(190, 225, 248, 0.8);font-size: 14px;width: 60%;">
          <el-form-item label="行业：" prop="tradeId">
            <div style="display: flex;">
              <el-select filterable v-model="infoForm.tradeId" @change="changeTrade">
                <el-option v-for="op in tradeList" :key="op.ID" :value="op.ID" :label="op.NAME" :disabled="1 - op.SUPPORT" />
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="企业名称：" prop="name">
            <div style="display: flex;">
              <el-input v-model="infoForm.name" style="width: 218px;"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="年份：" prop="year">
            <div style="display: flex;">
              <el-date-picker v-model="infoForm.year" type="year" value-format="yyyy" />
            </div>
          </el-form-item>
          <el-form-item label="省份：" prop="provinceId">
            <div style="display: flex;">
              <el-select filterable v-model="infoForm.provinceId">
                <el-option v-for="op in provinceList" :key="op.ID" :value="op.ID" :label="op.NAME" />
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="年产值：" prop="outputValue_10k">
            <div style="display: flex;">
              <el-input v-model.number="infoForm.outputValue_10k" style="width: 218px;"></el-input>
              <div style="margin-left: 5px;">万元</div>
            </div>
          </el-form-item>
        </el-form>
        <el-row v-if="carbonModel.ty.length > 0" style="height: 40px;line-height: 40px;margin-top: 20px;text-align: left;font-size: 14px;">
          碳排放源
        </el-row>
        <el-row style="background-color: rgba(246, 208, 212, 0.8)" v-for="(ty, k) in carbonModel.ty" :key="k">
          <el-row v-if="ty.data.length > 0" style="height: 40px;font-size: 14px;margin-top: 30px;width: 100%;line-height: 40px;">
            <el-col style="width: 100%;text-align: center;">{{ty.name}}</el-col>
          </el-row>
          <el-row style="width: 100%;line-height: 62px;font-size: 14px;" v-for="(tyData, i) in ty.data" :key="i">
            <el-col style="width: 31%;">
              <el-col style="width: 25%;margin-left: 5%;">类型</el-col>
              <el-input :disabled="true" v-model="tyData.name" class="input-disable-black" style="width: 150px;"></el-input>
            </el-col>
            <el-col style="width: 31%;text-align: left;">
              <el-col style="width: 25%;margin-left: 5%;">活动水平</el-col>
              <el-input type="number" v-model="tyData.weight" :placeholder="tyData.weightRemark" style="width: 150px;"></el-input>
              {{tyData.unit}}
            </el-col>
            <el-col style="width: 31%;">
              <el-col style="width: 25%;margin-left: 5%;">排放系数</el-col>
              <el-input v-model="tyData.f" placeholder="缺省值" style="width: 150px;"></el-input>
            </el-col>
          </el-row>
        </el-row>
        <el-row v-if="carbonModel.th.length > 0" style="height: 40px;line-height: 40px;margin-top: 20px;text-align: left;font-size: 14px;">
          碳排放汇
        </el-row>
        <el-row style="background-color: rgba(230, 246, 225, 0.8)" v-for="(ty, k) in carbonModel.th" :key="k">
          <el-row style="height: 40px;font-size: 14px;margin-top: 30px;width: 100%;line-height: 40px;">
            <el-col style="width: 100%;text-align: center;">{{ty.name}}</el-col>
          </el-row>
          <el-row style="width: 100%;line-height: 80px;font-size: 14px;" v-for="(tyData, i) in ty.data" :key="i">
            <el-col style="width: 31%;">
              <el-col style="width: 25%;margin-left: 5%;">类型</el-col>
              <el-input :disabled="true" v-model="tyData.name" class="input-disable-black" style="width: 150px;"></el-input>
            </el-col>
            <el-col style="width: 31%;text-align: left;">
              <el-col style="width: 25%;margin-left: 5%;">活动水平</el-col>
              <el-input type="number" v-model="tyData.weight" :placeholder="tyData.weightRemark" style="width: 150px;"></el-input>
              {{tyData.unit}}
            </el-col>
            <el-col style="width: 31%;">
              <el-col style="width: 25%;margin-left: 5%;">排放系数</el-col>
              <el-input v-model="tyData.f" placeholder="缺省值" style="width: 150px;"></el-input>
            </el-col>
          </el-row>
        </el-row>
        <el-row style="height: 80px;font-size: 14px;margin-top: 20px;width: 100%;line-height: 60px;">
          <el-button type="primary" @click="genReport" :disabled="reportModel === 0">生成报告</el-button>
        </el-row>
      </div>
    </div>
    <carbon-report v-else :report-data="reportData" />
  </div>
</template>

<script>
import CarbonReport from "./CarbonReport";
import buildCarbonBarConfig from "../../../config/chart/config_carbon_bar";
import buildBarConfig from "../../../config/chart/config_cross_bar";
export default {
  name: "CarbonCheck",
  components: { CarbonReport },
  data() {
    return {
      infoForm: {
        tradeId: '',
        name: '',
        year: '',
        provinceId: '',
        outputValue_10k: ''
      },
      rules: {
        tradeId: [
          { required: true, message: '请选择行业', trigger: 'change' }
        ],
        name: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        year: [
          { required: true, message: '请选择年份', trigger: 'change' }
        ],
        provinceId: [
          { required: true, message: '请选择省份', trigger: 'change' }
        ],
        outputValue_10k: [
          { type: 'number', required: true, message: '请输入年产值(数字)', trigger: 'blur' }
        ]
      },
      tradeList: [],
      provinceList: [],
      yearList: [2021, 2022, 2023, 2024, 2025],
      carbonModel: {
        ty: [],
        th: []
      },
      reportModel: 0,
      reportData: ''
    }
  },
  created() {
    this.getTradeType()
    this.getAllProvince()
  },
  methods: {
    genReport() {
      this.$refs.infoForm.validate((valid) => {
        if (valid) {
          this.carbonModel.ty.forEach(item => {
            item.data.forEach(itemItem => {
              if (itemItem.weight.trim() === '') {
                itemItem.weight = 0
              }
            })
          })
          this.carbonModel.th.forEach(item => {
            item.data.forEach(itemItem => {
              if (itemItem.weight.trim() === '') {
                itemItem.weight = 0
              }
            })
          })
          this.reportData = ''
          let params = {tradeId: this.infoForm.tradeId, name: this.infoForm.name, year: this.infoForm.year, provinceId: this.infoForm.provinceId,
            outputValue_10k: this.infoForm.outputValue_10k, ty: this.carbonModel.ty, th: this.carbonModel.th}
          this.$api.carbonManage.genCarbonReport(this.infoForm.tradeId, params).then(res => {
            if (res.code === 200) {
              this.reportData = res.data
            }
          })
        }
      })
    },
    dataFormat(x, num = 1) {
      return parseFloat(x).toFixed(num)
    },
    changeTrade(val) {
      this.reportModel = 0
      let params = {tradeId: val}
      this.$api.carbonManage.getCarbonModel(params).then(res => {
        if (res.code === 200) {
          this.reportModel = 1
          this.carbonModel.ty = res.data.ty
          this.carbonModel.th = res.data.th
          this.carbonModel.ty.forEach(item => {
            item.data.forEach(itemItem => {
              this.$set(itemItem, 'weightRemark', itemItem.weight)
              itemItem.weight = ''
            })
          })
          this.carbonModel.th.forEach(item => {
            item.data.forEach(itemItem => {
              this.$set(itemItem, 'weightRemark', itemItem.weight)
              itemItem.weight = ''
            })
          })
        }
      })
    },
    getTradeType() {
      this.$api.carbonManage.getTradeType().then(res => {
        if (res.code === 200) {
          this.tradeList = res.data
        }
      })
    },
    getAllProvince() {
      this.$api.carbonManage.getAllProvince().then(res => {
        if (res.code === 200) {
          this.provinceList = res.data
        }
      })
    }
  }
}
</script>

<style>
  .input-disable-black .el-input__inner {
    color: #606266 !important;
    background-color: #fff !important;
  }
</style>
<style scoped>
  /** 去掉数字输入框上下箭头 **/
  /deep/
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/CarbonManage/CarbonCheck.vue